import toast, {Toast} from "react-hot-toast";

export function successToast(message: string) {
    toast.success(message);
}

export function errorToast(message: string) {
    toast.error(message);
}

export function uploadSuccess(message: string) {
  toast.custom(
    (t: Toast) => (
      <div
        className={[
          "mx-2 flex w-full items-center justify-between",
          "rounded-xl px-4 py-3",
          "bg-[var(--button-green)] text-white",                 
          "shadow-[0_12px_28px_-10px_rgba(0,0,0,0.35)] ring-1 ring-black/5",
          t.visible ? "animate-[fadeIn_120ms_ease-out]" : "animate-[fadeOut_120ms_ease-in]"
        ].join(" ")}
        role="status"
      >
        <span className="font-semibold tracking-tight">{message}</span>

        <button
          onClick={() => toast.dismiss(t.id)}
          aria-label="Dismiss"
          className="ml-4 grid h-7 w-7 place-items-center rounded-full hover:bg-white/10 focus:outline-none"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" className="opacity-95">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    ),
    { duration: 3000 } 
  );
}